import { render } from "./Affiliates.vue?vue&type=template&id=2e77672b&scoped=true"
import script from "./Affiliates.vue?vue&type=script&lang=js"
export * from "./Affiliates.vue?vue&type=script&lang=js"

import "./Affiliates.vue?vue&type=style&index=0&id=2e77672b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e77672b"]])

export default __exports__